var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9375 2.0625C1.69141 2.0625 1.5 2.28125 1.5 2.5V13C1.5 13.2461 1.69141 13.4375 1.9375 13.4375H8.0625C8.28125 13.4375 8.5 13.2461 8.5 13V2.5C8.5 2.28125 8.28125 2.0625 8.0625 2.0625H1.9375ZM0.1875 2.5C0.1875 1.54297 0.953125 0.75 1.9375 0.75H8.0625C9.01953 0.75 9.8125 1.54297 9.8125 2.5V13C9.8125 13.9844 9.01953 14.75 8.0625 14.75H1.9375C0.953125 14.75 0.1875 13.9844 0.1875 13V2.5ZM4.125 11.6875H5.875C6.09375 11.6875 6.3125 11.9062 6.3125 12.125C6.3125 12.3711 6.09375 12.5625 5.875 12.5625H4.125C3.87891 12.5625 3.6875 12.3711 3.6875 12.125C3.6875 11.9062 3.87891 11.6875 4.125 11.6875Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconPhone);
export default __webpack_public_path__ + "static/media/contact-icon-phone.236559cfe99eb4b8ab1242b4e3f41134.svg";
export { ForwardRef as ReactComponent };